import { LogItem } from "types";

export class Logger {
  private logs: LogItem[] = [];

  // Public Getters

  public get list() {
    return this.logs;
  }

  // Public Methods

  public create(log: string) {
    const time = performance.now();
    return { name: log, time } as LogItem;
  }

  public log(item: LogItem) {
    const time = performance.now();
    this.logs.push({ name: item.name, time: (time - item.time) / 1000 });
  }

  public clear() {
    this.logs = [];
  }
}
